import { configureStore } from "@reduxjs/toolkit";
import user from "./userSlice";
import serverSettingsStatus from "./fell/serverSettings/serverSettingsSlice";
import projectsSlice from "./fell/projects/projectsSlice";
import sitesSlice from "./fell/sites/sitesSlice";
import siteDesignSlice from "./fell/siteDesign/siteDesignSlice";
import siteDesignEditorSlice from "./fell/siteDesignEditor/siteDesignEditorSlice";
import cameraSlice from "./fell/camera/cameraSlice";
import proposalSlice from "./fell/proposals/proposalSlice";
import serverSettingsSlice from "./fell/serverSettings/serverSettingsSlice";
import bulkApplySlice from "./fell/bulkapply/bulkApplySlice";
import toolsActionSlice from "./fell/tools/toolsSlice";

export const store = configureStore({
    reducer: {
        user,
        serverSettingsStatus,
        projects: projectsSlice,
        sites: sitesSlice,
        siteDesign: siteDesignSlice,
        siteDesignEditor: siteDesignEditorSlice,
        cameras: cameraSlice,
        proposal: proposalSlice,
        serverSettings: serverSettingsSlice,
        bulkApply: bulkApplySlice,
        toolsAction: toolsActionSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;